import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { usePersonalTabsData } from 'shared/hooks/usePersonalTabsData'
import { EPersonalAreaTabs } from 'types/enums/EPersonalAreaTabs'
import {
  StyledComingSoonSpan,
  StyledComingSoonSpanConatiner,
  TabContainer,
} from './style'
import { Tabs, Tab } from '@mui/material'
import { useIsMobile } from 'shared/hooks/useIsMobile'

type tabsProps = {
  setTabTitle: React.Dispatch<React.SetStateAction<string>>
}

const PersonalAreaTabs: React.FC<tabsProps> = ({ setTabTitle }) => {
  const [activeTab, setActiveTab] = useState<string | null>(
    EPersonalAreaTabs.LOBBY,
  )
  const { t } = useTranslation('', {
    keyPrefix: 'pages.personalArea',
  })

  const tabs = usePersonalTabsData()
  const isMobile = useIsMobile()
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue)
    setTabTitle(newValue)
  }

  return (
    <TabContainer>
      <Tabs
        TabIndicatorProps={{
          style: {
            display: 'none', // Hide the default indicator
          },
        }}
        orientation={isMobile ? 'horizontal' : 'vertical'}
        value={activeTab}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons={false}
        sx={{
          '@media (min-width: 1024px)': {},
        }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.title.key}
            value={tab.title.key}
            label={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row-reverse',
                  width: 'max-content',
                }}
              >
                {tab.isComingSoon && (
                  <StyledComingSoonSpanConatiner>
                    <StyledComingSoonSpan>
                      {t('comingSoon.title')}!
                    </StyledComingSoonSpan>
                  </StyledComingSoonSpanConatiner>
                )}
                <span>{t(`tabs.${tab.title.key}.text`)}</span>
              </div>
            }
            sx={{
              fontFamily: '"Inter", sans-serif',
              fontSize: '14px',
              fontWeight: activeTab === tab.title.key ? '600' : '400',
              textDecoration: 'none',
              color:
                activeTab === tab.title.key
                  ? '#DD1C22 !important'
                  : 'black !important',
              borderBottom:
                activeTab === tab.title.key
                  ? '1px solid #DD1C22 !important'
                  : '1px solid transparent !important',
              cursor: 'pointer',
              padding: '8px 4px',
              width: 'max-content !important',
              marginBlockEnd: '16px',
              marginLeft: '12px',
              paddingBlockEnd: '0px',
              '@media (min-width: 1024px)': {
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '4px !important',
                textAlign: 'right',
                alignItems: 'baseline',
                width: '100% !important',
                padding: '12px 16px',
                color:
                  activeTab === tab.title.key
                    ? '#ffffff !important'
                    : '#000000 !important',
                backgroundColor:
                  activeTab === tab.title.key ? '#DD1C22' : 'transparent',
                marginBlockEnd: '0px',
                marginRight: '0px',
              },
            }}
          />
        ))}
      </Tabs>
    </TabContainer>
  )
}

export { PersonalAreaTabs }
